
import { useEffect, useState } from 'react';
import Button from '../../../components/base/Button';

export default function CTASection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const element = document.getElementById('cta');
    if (element) {
      observer.observe(element);
    }

    return () => observer.disconnect();
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="cta" 
      className="py-20 relative overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(0, 107, 187, 0.95) 0%, rgba(2, 153, 233, 0.9) 100%), url('https://readdy.ai/api/search-image?query=Professional%20business%20handshake%20in%20modern%20office%20setting%2C%20partnership%20and%20trust%20concept%2C%20corporate%20environment%20with%20blue%20tones%2C%20success%20and%20collaboration%2C%20clean%20minimalist%20background%20with%20natural%20lighting&width=1200&height=600&seq=cta-handshake&orientation=landscape')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-blue-600/80"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className={`text-center max-w-4xl mx-auto transform transition-all duration-1000 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" style={{ fontFamily: 'DM Sans, sans-serif' }}>
            Pronto para Transformar sua Contabilidade?
          </h2>
          
          <p className="text-xl md:text-2xl text-blue-100 mb-8 leading-relaxed">
            Junte-se aos empresários que já descobriram o poder do atendimento humanizado. 
            Vamos crescer juntos de forma sustentável e transparente.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a 
              href="https://wa.me/551146381343" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-full sm:w-auto"
            >
              <Button 
                size="lg"
                variant="outline"
                className="border-2 border-green-500 text-white bg-green-500 hover:bg-green-600 hover:border-green-600 hover:text-white w-full px-12 py-6  text-base sm:text-xl rounded-2xl shadow-2xl transition-all duration-300"
              >
                <i className="hidden sm:flex ri-whatsapp-line mr-3 text-2xl"></i>
                Falar no WhatsApp Agora
              </Button>
            </a>
          </div>
          
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8 text-center">
            <div className="text-white">
              <div className="text-3xl font-bold mb-2" style={{ fontFamily: 'DM Sans, sans-serif' }}>100%</div>
              <p className="text-blue-100">Contabilidade Digital</p>
            </div>
            <div className="text-white">
              <div className="text-3xl font-bold mb-2" style={{ fontFamily: 'DM Sans, sans-serif' }}>60+</div>
              <p className="text-blue-100">Anos de Experiência</p>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
}
